import { AUTH_BASE_URL } from 'src/environments/base-url';

export const authUrl = (): string => `${AUTH_BASE_URL}/user/login/auth`;
export const refreshAuthUrl = (): string => `${AUTH_BASE_URL}/user/login/refresh`;
export const initUserAuthUrl = (): string => `${AUTH_BASE_URL}/user/me`;
